/**
 *  HELYETTESÍTŐ-VÁLASZTÓ LISTÁJA.
 *
 *  A kiszolgáló (`/orarend/helyettesito-jeloltek`) tanáronként megmondja, ki foglalt az
 *  adott órában, ki van aznap bent, kinek lyukasórája van, ki szaktanár vagy tanítja az
 *  osztályt, és kinek hány helyettesítése van a héten. Ebből készül a csoportosított,
 *  rangsorolt lista – egy 40 fős tantestületben így nem kell mindenkit végignézni.
 *
 *  Helyettesítésnél a SZABADOK a relevánsak, összevonásnál viszont épp a foglaltak
 *  (akik abban az órában órát tartanak, és hozzájuk vonják az osztályt).
 */

export const HELYETTESITO_CSOPORTOK = [
  'Szabad · aznap bent van',
  'Szabad · aznap nincs órája',
  'Egyéb (nem tanít a tanévben, betöltetlen hely)',
  'Foglalt ebben az órában',
  'Az óra tartója',
];

export interface HelyettesitoListaBemenet {
  allomany: any[];
  jeloltek: { tanarok: Record<string, any> };
  osszevonas: boolean;
  /** Ki: csak a relevánsak (és a már kiválasztott); be: mindenki. */
  mindenki: boolean;
  kivalasztott: string;
  /** Az óra tartója – őt nem lehet önmaga helyettesítőjének választani. */
  tarto: string;
}

/** 1,2,3,5 → „1–3., 5.” */
export function oraTartomany(lista: number[]): string {
  const reszek: string[] = [];
  let i = 0;
  while (i < lista.length) {
    let j = i;
    while (j + 1 < lista.length && lista[j + 1] === lista[j] + 1) j++;
    reszek.push(i === j ? `${lista[i]}.` : `${lista[i]}–${lista[j]}.`);
    i = j + 1;
  }
  return reszek.join(', ');
}

export function helyettesitoLista(b: HelyettesitoListaBemenet): any[] {
  const CS = HELYETTESITO_CSOPORTOK;
  const ures = { foglalt: null, napiOrak: [], lyukas: false, szaktanar: false, osztalyTanara: false, hetiHelyettesites: 0, tanevbenTanit: false };

  const tetelek = (b.allomany || []).map((t: any) => {
    const adid = String(t?.adid ?? '');
    const info = b.jeloltek?.tanarok?.[adid] || ures;
    const sajat = !!b.tarto && adid === b.tarto;
    //  A „Betöltetlen Álláshely” jellegű helykitöltő nem ember: nem lehet helyettesítő.
    const helykitolto = /betöltetlen|álláshely/i.test(String(t?.full_name ?? ''));
    let csoportIndex: number;
    if (sajat) csoportIndex = 4;
    else if (helykitolto) csoportIndex = 2;
    else if (info.foglalt) csoportIndex = 3;
    else if ((info.napiOrak || []).length) csoportIndex = 0;
    else if (info.tanevbenTanit) csoportIndex = 1;
    else csoportIndex = 2;

    const cimkek: { szoveg: string; tipus: 'jo' | 'foglalt' | 'info' }[] = [];
    if (info.foglalt) {
      cimkek.push({ szoveg: `${info.foglalt.szerep}: ${[info.foglalt.cel, info.foglalt.tantargy].filter(Boolean).join(' ')}`, tipus: 'foglalt' });
    }
    if (!info.foglalt && info.lyukas) cimkek.push({ szoveg: 'lyukasóra', tipus: 'jo' });
    if (info.szaktanar) cimkek.push({ szoveg: 'szaktanár', tipus: 'jo' });
    if (info.osztalyTanara) cimkek.push({ szoveg: 'tanítja az osztályt', tipus: 'jo' });
    if ((info.napiOrak || []).length) cimkek.push({ szoveg: `aznap: ${oraTartomany(info.napiOrak)} óra`, tipus: 'info' });
    if (info.hetiHelyettesites) cimkek.push({ szoveg: `e héten ${info.hetiHelyettesites} helyettesítés`, tipus: 'info' });

    return {
      ...t,
      csoport: CS[csoportIndex],
      cimkek,
      disabled: sajat || helykitolto || (b.osszevonas ? !info.foglalt : !!info.foglalt),
      _rang: [csoportIndex, !info.foglalt && info.lyukas ? 0 : 1, info.szaktanar ? 0 : 1, info.osztalyTanara ? 0 : 1, info.hetiHelyettesites || 0],
    };
  });

  const lathato = b.mindenki
    ? tetelek
    : tetelek.filter((t: any) => (b.kivalasztott && String(t.adid) === b.kivalasztott)
      || (b.osszevonas ? t._rang[0] === 3 : (t._rang[0] === 0 || t._rang[0] === 1)));

  const sorrend = b.osszevonas ? [3, 0, 1, 2, 4] : [0, 1, 2, 3, 4];
  return lathato.sort((x: any, y: any) => {
    const cx = sorrend.indexOf(x._rang[0]);
    const cy = sorrend.indexOf(y._rang[0]);
    if (cx !== cy) return cx - cy;
    for (let i = 1; i < x._rang.length; i++) if (x._rang[i] !== y._rang[i]) return x._rang[i] - y._rang[i];
    return String(x.full_name || '').localeCompare(String(y.full_name || ''), 'hu');
  });
}
